import React, { useEffect, useMemo } from 'react';
import { HighLightsRequestNamespace } from '@tacans/shared-marketplace-layer';
import { useTranslation } from 'react-i18next';
import { RouteE } from 'src/constants/pages.constants';
import { Grid } from 'src/ui/common/atoms/grid';
import { LandingSection } from 'src/ui/common/layouts/landing-section';
import { CollectionCardBig } from '../../components/collection-card-big';
import { useHighlightedCollections } from '../../hooks/use-highlighted-collections';
import { CollectionCardBigPreloader } from '../../components/collection-card-big-preloader';

export const HighlightedCollectionsContainer = () => {
    const { t } = useTranslation(['pages']);
    const { fetch, clear, highlightedCollections, isLoading } = useHighlightedCollections();
    const locale: { title: string } = useMemo(()=>({
        ...t('home.widgets.highlightedCollections', { ns: 'pages', returnObjects: true }),
    }), [t]);

    useEffect(() => {
        fetch({
            namespace: HighLightsRequestNamespace.MAIN,
            pager: { page: 0, limit: 3 }
        });
        return clear;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <LandingSection seeMoreLink={RouteE.COLLECTIONS_LIST} title={locale.title}>
            <Grid rowGap={20} columnGap={20} xs={1} sm={3} md={3}>
                {isLoading && [...Array(3).keys()].map((el)=><CollectionCardBigPreloader key={el} />)}
                {!!highlightedCollections?.length && highlightedCollections!.map((collection) => (
                    <CollectionCardBig collection={collection} key={collection.id} />
                ))}
            </Grid>
        </LandingSection>
    );
};